var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.is_load } },
    [
      _vm.customer
        ? _c(
            "b-tabs",
            { attrs: { "content-class": "mt-3" } },
            [
              _c(
                "b-tab",
                { attrs: { title: _vm.__t("CLIENT_INFO"), active: "" } },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-4" }, [
                      _c("div", { staticClass: "card mb-3" }, [
                        _c("div", { staticClass: "card-body" }, [
                          _c("h5", { staticClass: "frame-heading mb-3" }, [
                            _vm._v(_vm._s(_vm.__t("CLIENT_DETAILS"))),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "mb-3" }, [
                            _c("div", { staticClass: "text-muted small" }, [
                              _vm._v(_vm._s(_vm.__t("NAME"))),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "font-weight-bold" }, [
                              _vm._v(_vm._s(_vm.customer.username || "—")),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "mb-3" }, [
                            _c("div", { staticClass: "text-muted small" }, [
                              _vm._v(_vm._s(_vm.__t("PHONE"))),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "font-weight-bold" }, [
                              _vm._v(_vm._s(_vm.customer.phone || "—")),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.customer.sources &&
                          _vm.customer.sources.length > 0
                            ? _c(
                                "div",
                                { staticClass: "mb-0" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "text-muted small mb-1" },
                                    [_vm._v(_vm._s(_vm.__t("SOURCES")))]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.customer.sources, function (s) {
                                    return _c(
                                      "span",
                                      {
                                        key: s.provider,
                                        staticClass:
                                          "badge badge-light border mr-1 mb-1",
                                      },
                                      [_vm._v(_vm._s(s.provider))]
                                    )
                                  }),
                                ],
                                2
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4" }, [
                      _c("div", { staticClass: "card mb-3" }, [
                        _c("div", { staticClass: "card-body text-center" }, [
                          _c("div", { staticClass: "text-muted small" }, [
                            _vm._v(_vm._s(_vm.__t("ORDERS"))),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "h3 mb-0" }, [
                            _vm._v(_vm._s(_vm.customer.orders.length)),
                          ]),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4" }, [
                      _c("div", { staticClass: "card mb-3" }, [
                        _c("div", { staticClass: "card-body text-center" }, [
                          _c("div", { staticClass: "text-muted small" }, [
                            _vm._v(_vm._s(_vm.__t("BONUSES"))),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "h3 mb-0" }, [
                            _vm._v(_vm._s(_vm.customer.bonuses)),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("b-tab", { attrs: { title: _vm.__t("FAVORITE_DISHES") } }, [
                _c("div", { staticClass: "card" }, [
                  _c(
                    "div",
                    { staticClass: "card-body" },
                    [
                      _vm._l(_vm.favorite_dishes, function (dish) {
                        return _c(
                          "div",
                          {
                            key: dish.title,
                            staticClass:
                              "d-flex align-items-center py-2 border-bottom",
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "badge badge-light border mr-3" },
                              [_vm._v(_vm._s(dish.qty) + "x")]
                            ),
                            _vm._v(" "),
                            dish.image
                              ? _c("img", {
                                  staticClass: "rounded mr-3",
                                  staticStyle: { "object-fit": "cover" },
                                  attrs: {
                                    src: dish.image,
                                    width: "32",
                                    height: "32",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex-grow-1" }, [
                              _vm._v(_vm._s(dish.title)),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "font-weight-bold" }, [
                              _vm._v(_vm._s(dish.total.toFixed(2))),
                            ]),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm.favorite_dishes.length === 0
                        ? _c("div", { staticClass: "text-muted" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.__t("NO_ORDERS_YET")) +
                                "\n                    "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("b-tab", { attrs: { title: _vm.__t("ORDER_HISTORY") } }, [
                _c("div", { staticClass: "card" }, [
                  _c(
                    "div",
                    { staticClass: "card-body p-0" },
                    [
                      _vm._l(_vm.customer.orders, function (o, idx) {
                        return _c(
                          "div",
                          {
                            key: o.id,
                            staticClass:
                              "d-flex align-items-center py-3 px-3 order-history-row",
                            class: {
                              "border-bottom":
                                idx < _vm.customer.orders.length - 1,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.open_order(o)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "order-history-icon mr-3" },
                              [
                                o.provider && o.provider.icon_url
                                  ? _c("img", {
                                      staticClass: "order_prov_image",
                                      attrs: {
                                        src: o.provider.icon_url,
                                        alt: "",
                                      },
                                    })
                                  : _c("i", {
                                      staticClass: "fal fa fa-file-o fa-file",
                                    }),
                              ]
                            ),
                            _vm._v(" "),
                            o.products && o.products.length > 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-items-center product-stack mr-3",
                                  },
                                  [
                                    _vm._l(
                                      o.products.slice(0, 4),
                                      function (p, pidx) {
                                        return _c("img", {
                                          key: pidx,
                                          staticClass: "product-stack-img",
                                          style: { zIndex: 10 - pidx },
                                          attrs: { src: p.image, alt: "" },
                                        })
                                      }
                                    ),
                                    _vm._v(" "),
                                    o.products.length > 4
                                      ? _c(
                                          "div",
                                          { staticClass: "product-stack-more" },
                                          [
                                            _vm._v(
                                              "\n                                +" +
                                                _vm._s(o.products.length - 4) +
                                                "\n                            "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex-grow-1 min-width-0 mr-3" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "font-weight-bold text-truncate",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(o.order_code) +
                                        "\n                                "
                                    ),
                                    o.is_rejected
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "badge badge-danger ml-2",
                                          },
                                          [_vm._v(_vm._s(_vm.__t("REJECTED")))]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v(
                                    _vm._s(o.created_at) +
                                      " · " +
                                      _vm._s(o.product_count) +
                                      " " +
                                      _vm._s(_vm.__t("ITEMS"))
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "font-weight-bold text-nowrap" },
                              [_vm._v(_vm._s(o.cost))]
                            ),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm.customer.orders.length === 0
                        ? _c("div", { staticClass: "text-muted p-3" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.__t("NO_ORDERS_YET")) +
                                "\n                    "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
              ]),
            ],
            1
          )
        : !_vm.is_load
        ? _c("div", { staticClass: "text-muted text-center p-4" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.__t("NO_CUSTOMER_ATTACHED")) + "\n    "
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }